module.exports = __webpack_public_path__ + "static/media/Step5a.4d8b36d3.jpg";